import { render, staticRenderFns } from "./colleagueOrders.vue?vue&type=template&id=58f2a1ee&scoped=true&"
import script from "./colleagueOrders.vue?vue&type=script&lang=js&"
export * from "./colleagueOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2a1ee",
  null
  
)

export default component.exports